Revealizr.detectFeatures();

var resizeTimer;
$(window).on('resize', function(e) {
    Revealizr.detectFeatures();
    clearTimeout(resizeTimer);
});

/*Smooth Scroll*/
/* https://css-tricks.com/snippets/jquery/smooth-scrolling/ */
$(function() {
  $('.backToTop-link a').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
        return false;
      }
    }
  });
});

function injectSVG(parentElement) {
    var mySVGsToInject;
    if (parentElement != null) {
        mySVGsToInject = parentElement.querySelectorAll('img.inject-me');
    } else {
        mySVGsToInject = document.querySelectorAll('img.inject-me');
    }
    SVGInjector(mySVGsToInject);
}

// Global var
let linkInternalPositionModifier = '';

jQuery(document).ready(function () {
	'use strict';

	// Must be called before Dishide
	closedForSession();
	openModalOnLoad();

	injectSVG();

    // lightbox
    jQuery(".fancybox").fancybox({
        beforeLoad: function () {
            var el, id = $(this.element).data('fancybox');

            if (id) {
                el = $('#' + id);

                if (el.length) {
                    this.title = el.html();
                }
            }
        }
    });

    //Open a new target for links beginning with http/https
    jQuery('a[href^="http://"]').click(function () {
        if (this.rel != 'internal') {
            this.target = '_blank';
        }
    });

    // We disable link with class .disabled
    $("a.disabled").on("click", function (event) {
        event.preventDefault();
    });

    initFormMasks();

    // DISHIDE  //
	$('[data-module~="dishide"]').dishide();

	// Carousel : 5 images en desktop
	$('[data-module~="carousel-image"]').carousel_slick({
		dots: false
	});

	carouselSlick();
    pdpCarouselSlick();
    productTileSlick();
    productTileSlickPlusBanner();
    flyerTileSlick();
    accountOverviewDiscountCouponsSlick();

    if( Revealizr.isMobileSize ) {
		linkInternalPositionModifier = '.header-primary, #headerSearchForm';
	} else {
		linkInternalPositionModifier = '.header-primary';
	}

	// Link internal onload
	if( document.querySelector( '#container.vitrine' ) !== null ) {
		$(window).link_internal({
			positionModifier: linkInternalPositionModifier,
			positionModifierMultiplier: 2
		});
	}

	// Link internal
	$('#container.vitrine [data-module~="link-internal"] ').link_internal({
		positionModifier: linkInternalPositionModifier,
		positionModifierMultiplier: 2
	});

	$('#container.template-checkout [data-module~="link-internal"] ').link_internal({
		positionModifier: 20
	});

	$('[data-module~="back-top"] ').backTop();

	// Display or hide the checkout's carousel
	$('.order-summary-wrapper .osw__display-list, .order-summary-wrapper .osw__hide-list').on('click.order-list-display', function(){
		var order_summary_wrapper = $(this).closest('.order-summary-wrapper');
		order_summary_wrapper.find( '.osw__display-preview' ).click();
	});

	$('[data-module~="show-password"]').showPassword();

    externalLinkAssist();

    $('.btnChangeLang').on('click', function () {
        window.location.href = $('.js-change-my-language').attr('href');
    });
});

function initFormMasks() {
    // Input tel mask injection
    initTelMask();

    initPostalCodeMask();

    $('[type="number"][max="9"]').mask('0');
    $('[type="number"][max="999"]').mask('000');
    $('[type="number"][max="9999"]').mask('0000');
    $('[type="number"][max="99999"]').mask('00000');
    $('[type="number"][max="999999999"]').mask('000000000');

    // Input maxlength mask injection (android bug fallback)
    $('.android .mmc--form-input1, .android .mmc--form-input2, .android .mmc--form-input3').each(function __maxlengthMask(){
        var maskpattern = "";
        for (var i = this.maxLength - 1; i >= 0; i--) {
            maskpattern += "0";
        }

        $(this).mask(maskpattern);
    });
}

function initPostalCodeMask(containerPostalCode, selectorPostalCode) {
    const postalCodeInputsSelectors = 'input[name$=postalCode],input[name$=deliveryPostalCode],input[name$=addressPostalCode],input[name$=cardAddressPostalCode],input[name$=confirmationPostalCode],input[name$=commPostalCode]';
    var $postalCodes;
    if (selectorPostalCode !== undefined) {
        $postalCodes = containerPostalCode ? $(selectorPostalCode, containerPostalCode) : $(selectorPostalCode);
    } else {
        $postalCodes = containerPostalCode ? $(postalCodeInputsSelectors, containerPostalCode) : $(postalCodeInputsSelectors);
    }
    $postalCodes.mask('S0S 0S0');
}

function initTelMask(containerTel) {
    var $tels = containerTel ? $('input[type=tel]', containerTel) : $('input[type=tel]');
    $tels.mask('000-000-0000');
}

function manageSearchButtonWithEraseButton($inputSearch) {
    var $parentForm = $inputSearch.closest('form, .form');
    var $buttonClose = $parentForm.find('.input-close');
    if ($buttonClose.length) {
        if ($inputSearch.val() !== '') {
            $buttonClose.removeClass('field_is_empty');
        } else {
            $buttonClose.addClass('field_is_empty');
        }
    }
}

//Reload an image by its id
function reloadImg(id) {
    'use strict';
    var obj = document.getElementById(id);
    var src = obj.src;
    var pos = src.indexOf('?');
    if (pos >= 0) {
        src = src.substr(0, pos);
    }
    var date = new Date();
    obj.src = src + '?v=' + date.getTime();
    return false;
}

function sendGa4Information() {
    let ga4LoginInformation = TINK.getCookie('ga4LoginInformation');
    if (typeof ga4LoginInformation !== 'undefined' && ga4LoginInformation !== null) {
        let ga4LoginInformationArray = ga4LoginInformation.split(",");
        let ga4RegisteredAccount = decodeURIComponent(ga4LoginInformationArray[0]);
        let ga4UserEcomSegment = decodeURIComponent(ga4LoginInformationArray[1]);
        let ga4UserLoyaltyProgram = decodeURIComponent(ga4LoginInformationArray[2]);

        TINK.deleteCookie('ga4LoginInformation');
        pushDataLayerLoginValidate(ga4RegisteredAccount, ga4UserEcomSegment, ga4UserLoyaltyProgram)
    }
}

//Debug anchor For iPhone
document.addEventListener("DOMContentLoaded", () => {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const hash = window.location.hash.slice(1);
    const element = document.getElementById(hash);

    if (isiOS && element) {
        element.scrollIntoView();
    }
});